module.exports = __webpack_public_path__ + "img/Logo_spalm_azul.5a0b0060.svg";